/**
 * Munkamenet-csere közben elkésett kérés újraküldése.
 *
 * Belépéskor (SSO-nál, átjelentkezéskor) a szerver új munkamenetet ad. Egy még a régi sütivel
 * elindult kérés erre 401/419-et kap, és a szerver `X-Session-Stale` fejléccel jelzi, hogy ez
 * NEM kijelentkezés, csak a csere előtti süti (backend: App\Http\Middleware\StartSession).
 * Ilyenkor a kérést rövid várakozás után újraküldjük — addigra a böngészőben az új süti áll —,
 * és NEM léptetünk ki. A két alkalmazás (admin, portál) ugyanezt a fájlt használja; ha
 * változik, mindkettőben kell.
 */
const MAX_RETRIES = 3;
const DELAY_MS = 300;

export function isStaleSessionError(error) {
    return [401, 419].includes(error?.response?.status)
        && String(error?.response?.headers?.["x-session-stale"] || "") === "1";
}

/** Újraküldés ígérete, vagy `null`, ha a hiba nem elkésett munkamenet, vagy elfogyott a próba. */
export function retryStaleSession(client, error) {
    const config = error?.config;

    if (!config || !isStaleSessionError(error)) {
        return null;
    }

    config.__staleRetries = (config.__staleRetries || 0) + 1;

    if (config.__staleRetries > MAX_RETRIES) {
        return null;
    }

    return new Promise((resolve) => setTimeout(resolve, DELAY_MS * config.__staleRetries))
        .then(() => client.request(config));
}
